module.exports = __webpack_public_path__ + "static/media/1006143.0b9cf7ba.png";